<template>
  <!-- <div v-if="$buttonAuthority(allButton, 'list')"> -->
  <div class="search-class">
    <el-form :rules="rules" :model="dataObj" :inline="true" size="small" class="serarch-form" label-width="100px"
      ref="ruleForm">
      <div v-if="email">
        <div>
          <el-form-item label="收件人：" prop="recipientAddress">
            <!-- <p v-if="isLoading" class="spanText-error">
              正在通过订单号获取收件人，请稍后。。。
            </p> -->
            <el-input v-model="dataObj.recipientAddress" style="width: 300px"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="标题：" prop="title">
            <!-- <el-input v-model="dataObj.title" style="width: 300px"></el-input> -->
            <el-autocomplete style="width: 300px" v-model="dataObj.title" :fetch-suggestions="querySearch"
              placeholder="请输入内容" :trigger-on-focus="false" @change="setIntoStorage" clearable></el-autocomplete>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="模板选择：">
            <el-select v-model="test" clearable filterable placeholder="请选择" style="width: 300px" @change="setContent">
              <el-option v-for="(val, key, i) in dropList.templateName" :label="val" :value="val" :key="i"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="订单编号：" prop="orderId">
            <el-input v-model="dataObj.orderId" @change="getOrder" style="width: 300px"></el-input>
          </el-form-item>
        </div>

        <div class="consy">
          <el-form-item label="正文：" class="consy-content" prop="content">
            <!-- <el-input
              type="textarea"
              v-model="dataObj.content"
              :rows="12"
            ></el-input> -->
            <div style="height: 352px">
              <quill-editor style="height: 300px" v-model="dataObj.content" ref="myQuillEditor" class="editor"
                :options="myQuillEditor">
              </quill-editor>
            </div>
          </el-form-item>
          <div class="consy-right">
            <el-form-item>
              <el-select v-model="langObj.from" clearable filterable placeholder="源语言选择" style="width: 130px">
                <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
                  :key="i"></el-option>
              </el-select>
            </el-form-item>
            <div class="sort-div" @click="changeSort()">
              <i class="el-icon-sort" :style="{ color: tabcolors }"></i>
            </div>
            <el-form-item>
              <el-select v-model="langObj.to" clearable filterable placeholder="目标语言选择" style="width: 130px">
                <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
                  :key="i"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 130px; height: 35px" @click="translation">翻译</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="consy">
          <el-form-item label="备注：" class="consy-content">
            <el-input type="textarea" v-model="dataObj.remark" :rows="3"></el-input>
          </el-form-item>
        </div>
        <div class="muban">
          <el-checkbox v-model="checked" style="margin-top: 6px; margin-right: 20px">设置为模板</el-checkbox>
          <div v-if="checked == 1">
            <el-form-item>
              <el-select v-model="dataObj.temLanguages" clearable filterable placeholder="请选择模板语种" style="width: 200px">
                <el-option v-for="(val, key, i) in dropList.TemplateLanguages" :label="val" :value="key"
                  :key="i"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataObj.temType" clearable filterable placeholder="请选择模板类型" style="width: 200px">
                <el-option v-for="(val, key, i) in dropList.TemplateType" :label="val" :value="key" :key="i"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="bottom">
          <el-button v-if="$buttonAuthority(allButton, 'send')" type="primary" @click="sendMail('send')"
            :loading="loading">发送</el-button>
          <el-button v-if="$buttonAuthority(allButton, 'save')" type="primary"
          :loading="isLoad"
           @click="sendMail('save')">存入草稿箱</el-button>
          <upload buttonName="上传附件" :url="url" :param="uploadObj" :text="''" style="margin-left: 10px"
            @getImgName="getImgName" @getImgSrc="getImgSrc" :accept="'.jpg,.jpeg,.png,.pdf'"></upload>
          <p style="line-height: 32px; color: #ff0000">
            只允许上传<=10M的图片or文档，支持格式：jpg、png、pdf </p>

              <!-- <el-button type="primary">上传附件</el-button> -->
        </div>
        <div class="bottom" style="margin-top: 25px">
          <!-- 图片 -->
          <el-tag class="tag-annex" v-show="imgName.length > 0" v-for="(item, index) in imgName" :key="index" closable
            size="medium" :disable-transitions="false" @close="handleDel(index, item)" @click="seeImg(index)">
            <i class="el-icon-picture-outline"></i>
            <span>{{ item.fileList }}</span>
          </el-tag>
          <!-- pdf -->
          <el-tag class="tag-annex" v-show="pdfSrc.length > 0" v-for="(item, index) in pdfSrc" :key="index" closable
            size="medium" :disable-transitions="false" @close="handleDelPdf(index)" @click="seePdf(item)">
            <i class="el-icon-document"></i>
            <span>{{ item.fileList }}</span>
          </el-tag>
        </div>
      </div>
      <!-- 翻译 -->
      <div v-if="!email">
        <div style="padding: 20px 0">
          <el-form-item>
            <el-select v-model="langObj.from" clearable filterable placeholder="源语言选择" style="width: 130px">
              <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
                :key="i"></el-option>
            </el-select>
          </el-form-item>
          <span class="sort-css" @click="changeSort()">
            <i class="el-icon-sort" :style="{ color: tabcolors }"></i>
          </span>
          <el-form-item>
            <el-select v-model="langObj.to" clearable filterable placeholder="目标语言选择" style="width: 130px">
              <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
                :key="i"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 130px; height: 35px" @click="translateClick">翻译</el-button>
            <el-button type="primary" style="width: 130px; height: 35px" @click="translation">写入正文</el-button>
            <el-button icon="el-icon-d-arrow-left" style="height: 35px" @click="email = true">返回</el-button>
          </el-form-item>
          <div class="fnsyin">
            <div class="fnsyin-cons">
              <el-form-item label="正文：" label-width="60px">
                <el-input type="textarea" v-model="langObj.query" :rows="12"></el-input>
              </el-form-item>
            </div>
            <div class="fnsyin-cons">
              <el-form-item label="译文：" label-width="60px">
                <el-input type="textarea" v-model="newText" :rows="12"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <imgView :dialog.sync="isShowImg" :imgList="imgView_msg.list" :imgIndex="imgView_msg.index" :ImgUrl="ImgUrl">
    </imgView>
  </div>
  <!-- </div> -->
</template>

<script>
/**
 * 亚马逊邮件发送/编辑页
 * 功能：收件人、标题自动补全、邮件模板选择、订单号反查收件人、富文本正文、多语种翻译、附件上传（图/pdf）、
 *       发送或存入草稿箱；支持草稿箱/差评列表跳转带参回显（type=send 为普通发送，其余为草稿重发）
 */
import {
  getLanguage,
  getTemplate,
  amazonSendEmail,
  saveDrafts,
  resendDraftsEmail,
  judgeOrderNo,
  translate,
} from "@/api/user";
import { isEmailReg } from "@/utils/validate";
import imgView from "./components/imgView";
import serverPath from "@/config/config.js";
export default {
  components: { imgView },
  data() {
    return {
      // 订单号反查收件人时的加载状态
      isLoading: false,
      // 是否打开图片查看弹窗
      isShowImg: false,
      imgView_msg: {
        show: false, //是否打开图片查看
        index: 0, //图片查看下标
        list: [], //图片列表
      },
      // 是否显示编辑区（false 时显示翻译区）
      email: true,
      // 是否设置为模板
      checked: "",
      // 按钮权限列表
      allButton: [],
      // 选中的模板名
      test: "",
      // 邮件表单数据：收件人、标题、正文、附件、订单号、模板语种/类型、备注
      dataObj: {
        id: "",
        recipientAddress: "",
        title: "",
        content: "",
        picture: null,
        orderId: "",
        temLanguages: "",
        temType: "",
        remark: "",
      },
      platformAccount: [],
      // 主题色
      tabcolors: "",
      // 语种列表
      languageArr: [],
      rules: {
        recipientAddress: [
          { required: true, message: "请输入收件人", trigger: "change" },
          // { validator: isEmailReg, trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "change" }],
        orderId: [
          { required: true, message: "请输入订单编号", trigger: "change" },
        ],
        content: [
          { required: true, message: "请输入邮件内容", trigger: "change" },
        ],
      },
      // 翻译结果文本
      newText: "",
      // 翻译参数：源语言/目标语言/待翻译文本
      langObj: {
        from: "zh",
        to: "en",
        query: "",
      },
      // 上传成功的图片地址列表
      imgUploadList: [],
      // 上传成功的 pdf 附件列表
      pdfSrc: [],
      imgName: [], //上传成功的图片名称
      // 图片上传成功标记
      isIMg: false,
      UploadingUrl: "",
      // 附件上传地址
      url: "/crm/yy-attachment/upload/images",
      // 上传附加参数
      uploadObj: {},
      myQuillEditor: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ["clean"],
            ],
            handlers: {
              image: this.showUploadDialog,
            },
          },
        },
        placeholder: "请输入邮件信息",
      },
      // 邮件类型（send 普通发送，其余为草稿重发）
      type: "send",
      // 发送按钮加载状态
      loading: false,
      // 存草稿按钮加载状态
      isLoad: false
    };
  },
  computed: {
    dropList: {
      get() {
        return this.$store.getters.dropList;
      },
    },
    userID() {
      return this.$store.getters.userId;
    },
    ImgUrl() {
      const env = serverPath.env;
      if (env === "test" || env === "dev" || env === "localhost") {
        return serverPath.serverPath.server + "/";
      } else {
        return "http://images.delaman168.com/crm/";
      }
    },
  },
  created() {
    // 初始化清空表单与附件，设置主题色
    this.$delectObj(this.dataObj);
    this.dataObj.picture = null;
    this.imgName = [];
    this.tabcolors = this.$store.getters.color; // 公共颜色
  },
  activated() {
    // 页面激活时初始化下拉与语种数据
    this.init();
    // 权限获取
    this.allButton = this.$getStorage(this.$route.name + "_button");
    this.$nextTick(() => {
      const obj = JSON.stringify(this.$route.query);
      if (obj !== "{}") {
        this.getInfo(this.$route.query);
      }
    });
  },
  methods: {
    querySearch(queryString, cb) {
      // 调用 callback 返回建议列表的数据
      let arr = this.$getStorage("AmazonSendTitle");
      let newArr = [];
      let results = [];
      if (arr && arr.length > 0) {
        results = arr.filter((item) => {
          return item.value.includes(queryString);
        });
        // 限制最多显示8条
        if (results.length > 8) {
          newArr = results.slice(0, 8);
        } else {
          newArr = results;
        }
      }
      return cb(newArr);
    },
    setIntoStorage(val) {
      let strArr = [];
      if (val && val !== "") {
        strArr.push({
          value: val,
        });
        // 获取已存在的记录
        let history = this.$getStorage("AmazonSendTitle");
        if (history && history.length > 0) {
          let arr = history.map((item) => item.value);
          if (arr.indexOf(val) > -1) {
            // 判断是否已有此条查询记录，若已存在，则不需再存储
            return;
          }
          //  把搜索记录存入localStorage
          this.$setStorage(
            "AmazonSendTitle",
            strArr.concat(this.$getStorage("AmazonSendTitle"))
          );
        } else {
          // 首次创建
          this.$setStorage("AmazonSendTitle", strArr);
        }
      }
    },
    // 获取草稿箱和亚马逊差评列表跳转传过来的数据
    // 重发邮件暂时没跳转
    getInfo(obj) {
      this.type = obj.type == undefined ? "send" : obj.type;
      this.dataObj.id = obj.id ? obj.id : "";
      this.dataObj.content = obj.context ? obj.context : "";
      this.dataObj.title = obj.subject ? obj.subject : "";
      this.dataObj.senderAccount = obj.sender ? obj.sender : "";
      this.dataObj.recipientAddress = obj.recipients ? obj.recipients : "";
      this.dataObj.senderAddress = obj.sender ? obj.sender : "";
      this.dataObj.orderId = obj.orderNo ? obj.orderNo : "";
      this.dataObj.remark = obj.remark ? obj.remark : "";
    },
    getImgName(val) {
      // 获取上传成功图片名称
      val.forEach((item) => {
        // this.imgName.push(item);
      });
      this.isIMg = true;
    },
    getImgSrc(val) {
      // 获取图片地址
      val.forEach((item) => {
        this.imgUploadList.push(item.urlList);
        if (item.fileList.split(".")[1] == "pdf") {
          this.pdfSrc.push(item);
        } else {
          this.imgName.push(item);
          this.imgView_msg.list.push(item.urlList);
        }
      });
      this.dataObj.picture = this.imgUploadList;
    },
    /** 新窗口打开 pdf 附件预览 */
    seePdf(item) {
      window.open(this.ImgUrl + item.urlList, "_blank");
    },
    // 查看大图
    seeImg(index) {
      this.imgView_msg.index = index;
      this.isShowImg = true;
    },
    /** 移除已上传的图片附件 */
    handleDel(index, item) {
      this.imgName.splice(index, 1);
      this.imgView_msg.list.splice(index, 1);
      this.dataObj.picture.splice(item.urlList, 1);
    },
    /** 移除已上传的 pdf 附件（删除图片列表时引用未定义变量 item，存在报错隐患） */
    handleDelPdf(index) {
      this.pdfSrc.splice(index, 1);
      this.dataObj.picture.splice(item.urlList, 1);
    },
    init() {
      this.$store.dispatch("getDropListTwo", [
        "templateName",
        "TemplateLanguages",
        "TemplateType",
      ]);
      getLanguage().then((res) => {
        if (res.code === 200) {
          this.languageArr = res.data;
        }
      });
    },
    // 语种交换
    changeSort() {
      const to = this.langObj.to;
      const from = this.langObj.from;
      this.langObj.to = from;
      this.langObj.from = to;
    },
    // 翻译点击
    translation() {
      this.email = !this.email;
      this.langObj.query = this.dataObj.content;
      if (this.newText !== "") {
        this.dataObj.content = this.newText;
      }
    },
    // 翻译
    translateClick() {
      this.newText = "正在翻译，请稍等...";
      translate(this.langObj).then((res) => {
        if (res.code === 200) {
          this.newText = res.data;
        }
      });
    },
    // 校验订单编号
    getOrder(value) {
      if (value === "") return false;
      this.isLoading = true;
      judgeOrderNo({ orderId: value })
        .then((res) => {
          if (res.code === 200) {
            this.isLoading = false;
            this.dataObj.recipientAddress = res.data.recipients.customerEmail;
          }
        })
        .catch((error) => {
          this.dataObj.orderNo = "";
        });
    },
    // 选择模板
    setContent(val) {
      // 根据模板名称获取模板内容
      getTemplate({ name: val }).then((res) => {
        if (res.code === 200) {
          this.dataObj.content = res.data;
        }
      });
    },
    // 提交
    sendMail(str) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (str === "send") {
            this.loading = true;
            const obj = JSON.stringify(this.$route.query);
            if (this.type == "send") {
              // 发送邮箱
              amazonSendEmail(this.dataObj).then((res) => {
                if (res.code === 200) {
                  this.loading = false;
                  if (res.data.status == 0) {
                    this.$message.error("发送失败！");
                  } else {
                    this.$message.success(res.data.msg);
                  }
                }
              }).catch(() => {
                this.loading = false;
              });
            } else {
              // 草稿箱邮件重新发送
              let { orderId, ...param } = this.dataObj;
              param.orderNo = this.dataObj.orderId;
              resendDraftsEmail(param).then((res) => {
                if (res.code === 200) {
                  this.loading = false;
                  this.$message.success(res.msg);
                  // this.$delectObj(this.dataObj);
                  this.$router.push("/drafts");
                }
              }).catch(() => {
                this.loading = false;
              });
            }
          } else {
            // 存草稿箱
            this.isLoad = true;
            let { orderId, ...param } = this.dataObj;
            param.orderNo = this.dataObj.orderId;
            saveDrafts(param).then((res) => {
              if (res.code === 200) {
                this.isLoad = false;
                if (res.data.Fail) {
                  this.$message.error(res.data.Fail);
                } else {
                  this.$message.success(res.data.Seccess);
                }
              }
            }).catch(() => {
              this.isLoad = false;
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form /deep/ .el-icon-sort {
  transform: rotate(90deg);
}

.el-form /deep/ .consy {
  width: 100%;

  .consy-content {
    width: 70%;

    .el-form-item__content {
      width: 91%;
      display: inline-block;
    }

    textarea {
      width: 100%;
    }
  }

  .consy-right {
    width: 10%;
    display: inline-block;
  }
}

.bottom {
  display: flex;
  margin-left: 110px;

  button {
    width: 100px;
  }

  .tag-annex {
    margin-right: 20px;
    cursor: pointer;
  }
}

.el-form /deep/ .muban {
  padding: 20px 100px;
  display: flex;
  height: 51px;
}

.el-form /deep/ .fnsyin {
  display: flex;

  .fnsyin-cons {
    width: 500px;

    textarea {
      width: 480px;
    }
  }
}

.el-form /deep/ .sort-css {
  margin-top: 7px;
  margin-bottom: 5px;
  margin-left: -10px;
  text-align: center;
  width: 50px;
  display: inline-block;
  cursor: pointer;
}

.el-form /deep/ .sort-div {
  margin-top: -10px;
  margin-bottom: 5px;
  text-align: center;
  width: 130px;
  cursor: pointer;
}
</style>